import { ValidatorFn } from '@angular/forms';

export const dateValidator: ValidatorFn = (ctrl) => {
  const value = ctrl.value;
  if (!value) {
    return { required: true };
  }
  if (value.replace("/", "").length > 0 && value.replace("/", "").length < 6) {
    return {dateFormat: true};
  }
  if (/[a-zA-Z]/.test(value)) {
    return {dateFormat: true};
  }
  const dateValue = new Date(value);  
  if (isNaN(dateValue.valueOf())) {
    return { dateFormat: true };
  } 
  
  const todayDate = new Date();
  const yearsDiff = todayDate.getFullYear() - dateValue.getFullYear();
  if (yearsDiff > 7) {
    return { checkYears: true };
  }  
  if (todayDate < dateValue) {
    return { checkDay: true };
  }  

  return null;
};

export const dateFromValidator: ValidatorFn = (ctrl) => {  
  const fromControl = ctrl.parent?.get('fromDate');
  const toControl = ctrl.parent?.get('toDate');
  if(!toControl || !fromControl) {
    return null
  }
  if (fromControl?.pristine || toControl?.pristine) {
      return null;
  }
  const from = Date.parse(fromControl?.value).valueOf();
  const to = Date.parse(toControl?.value).valueOf();
  if (from < to) {
    toControl?.setErrors(null);
    toControl?.updateValueAndValidity();
    return null;
  }
  else if (from > to) {    
    toControl?.updateValueAndValidity();
    return null;
  }
  return null;
};

export const dateToValidator: ValidatorFn = (ctrl) => {  
  const fromControl = ctrl.parent?.get('fromDate');
  const toControl = ctrl.parent?.get('toDate');
  if(!toControl || !fromControl) {
    return null
  }
  if (fromControl?.pristine || toControl?.pristine) {
      return null;
    }
  const from = Date.parse(fromControl?.value).valueOf();
  const to = Date.parse(toControl?.value).valueOf();
  if (from > to) {    
    return { dateCompare: true };
    }
  return null;
};
